const browserClient = require('@slardar/web/sg').default; // 编译时可摆脱ts校验
// import browserClient from '@slardar/web/sg';

interface SlardarConfigParam {
  extractPid?: string; // 用于标识页面
  userId?: string;
}

export default function slardarInit(config: SlardarConfigParam) {
  const {
    extractPid = '',
  } = config;
  const bid = 'qingzhou_i18n';

  browserClient.init({
    bid,
    // 通用事件上下文
    // pid: '页面初始 pid',
    // userId: '用户标识',
    // deviceId: '设备标识',
    /* eslint-disable-next-line no-undef */
    release: BUILD_VERSION, // 区分不同版本
    /* eslint-disable-next-line  no-undef */
    env: ZONE, // 区分不同环境
    // useLocalConfig: false, // 是否只使用本地配置，默认为关

    // 进阶配置
    domain: 'mon.tiktokv.com',
    pluginPathPrefix: 'https://sf16-website-login.neutral.ttwstatic.com/obj/tiktok_web_login_static/slardar/fe/sdk-web/plugins',
    plugins: {
      pageview: {
        // 指定 history 或 hash 变化时如何从 URL 中提取 pid，若
        routeMode: 'history', // 根据具体路由模式而定, 默认是history， 可选值有 'history' | 'hash' | 'manual'
        extractPid: () => extractPid,
      },
    }, // 插件配置， 具体格式在【详细配置 - 插件配置】中查看
  });
  return browserClient;
}

export function slardarConfig(config: SlardarConfigParam) {
  browserClient('config', {
    ...config,
  });
  browserClient('start');
}
